import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import { useState } from "react";

const ManageReviews = () => {

  const navigate = useNavigate();
  const [rows] = useState([
    {
      id: 1,
      bookingID: '#Book_001',
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      rating: "5",
      best: "Cleanliness",
      feedback: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
      date: "Sat, 10 Aug 2025, 11:00 AM"
    },
    {
      id: 2,
      bookingID: '#Book_002',
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      rating: "5",
      best: "Cleanliness",
      feedback: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
      date: "Sat, 10 Aug 2025, 11:00 AM"
    },
    {
      id: 3,
      bookingID: '#Book_003',
      name: "Madelyn Dias",
      email: "madelyndias@gmail.com",
      phone: "+91 9876543210",
      rating: "5",
      best: "Cleanliness",
      feedback: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. ",
      date: "Sat, 10 Aug 2025, 11:00 AM"
    },
  ]);

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Manage Reviews</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Reviews
        </p>
      </div>

      <div className="cards">

        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..." />
            </Box>
          </div>
        </div>
        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Booking ID</TableCell>
                <TableCell>Customer Detail</TableCell>
                <TableCell>Rating</TableCell>
                <TableCell>What did you like the best?</TableCell>
                <TableCell>Feedback</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow hover key={row.id}>
                  <TableCell>{row.bookingID}</TableCell>
                  <TableCell>
                    <a className="user_block click_action" onClick={() => navigate("/manage-users/detail")}>
                      <figure>
                        <img src="/static/images/user_placeholder.png" alt=""
                        />
                      </figure>
                      <p>
                        <b>{row.name}</b>
                        <span>{row.email}</span>
                        <span>{row.phone}</span>
                      </p>
                    </a>
                  </TableCell>
                  <TableCell>
                    <span className="star_rating">{row.rating} <StarRoundedIcon /></span>
                  </TableCell>
                  <TableCell>{row.best}</TableCell>
                  <TableCell className="max_c2">{row.feedback}</TableCell>
                  <TableCell>{row.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>

          </Table>
        </TableContainer>


      </div>
    </>
  );
};

export default ManageReviews;
